import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import parse from 'html-react-parser';
import CircleIcon from '@material-ui/icons/PanoramaFishEyeOutlined';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

import styles from './styles';

class Frise extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      speedDial: this.props.data.index.map(() => false),
      overlay: false,
    };
  }

  onClick(id) {
    this.props.onClick(this.props.index[id].x);
  }

  onClickSub(id, subId) {
    const sub = this.props.index[id].subBlocks[subId];
    this.props.onClick(sub.x);
  }

  onClickPopup(id, subId, popupId) {
    const item = subId !== null ? this.props.index[id].subBlocks[subId] : this.props.index[id];
    const popup = item.popups[popupId];
    this.props.onClick(item.x);
    this.props.onPopup(popup.anchor, true);
  }

  onSpeedDial(id, state) {
    this.setState(prev => {
      const speedDial = [...prev.speedDial];
      speedDial[id] = state;
      return { speedDial };
    });
  }

  toggleOverlay(overlay) {
    this.setState({ overlay });
  }

  renderPopups(item, idx, subItem, subId) {
    const { classes, scroll } = this.props;
    const parent = subItem || item;
    if (!parent.popups) {
      return null;
    }
    return parent.popups
      .map((popup, popupIdx) => (
        <Tooltip key={`popup_${popupIdx}`} title={parse(popup.title)} placement="right">
          <IconButton
            onClick={() => this.onClickPopup(idx, subId, popupIdx)}
            className={`${classes.menuButton}  ${-scroll >= parent.x ? classes.checked : ''}`}
          >
            <CircleIcon className={classes.icon} />
          </IconButton>
        </Tooltip>
      ))
      .reverse();
  }

  renderSubBlocks(item, idx) {
    const { classes, scroll } = this.props;
    if (!item.subBlocks) {
      return null;
    }
    return item.subBlocks
      .map((sub, subId) => (
        <React.Fragment key={`sub_${subId}`}>
          {this.renderPopups(item, idx, sub, subId)}
          {sub.hidden ? null : (
            <Tooltip key={`sub_${subId}`} title={parse(sub.title)} placement="right">
              <IconButton
                onClick={() => this.onClickSub(idx, subId)}
                className={`${classes.menuButton} ${-scroll >= sub.x - 10 ? classes.checked : ''} `}
              >
                <CircleIcon className={classes.icon} />
              </IconButton>
            </Tooltip>
          )}
        </React.Fragment>
      ))
      .reverse();
  }

  render() {
    const { classes, scroll, index } = this.props;
    const { speedDial, overlay } = this.state;
    const lineWidth = 100 / (index.length - 1);
    return (
      <>
        <Dialog open={overlay} className={classes.overlay}></Dialog>
        <div
          className={classes.container}
          onMouseEnter={() => this.toggleOverlay(true)}
          onMouseLeave={() => this.toggleOverlay(false)}
        >
          <div className={classes.lineContainer}>
            {index.map((item, idx) => {
              if (idx >= index.length - 1) {
                return null;
              }
              return (
                <div
                  key={idx}
                  className={classes.line}
                  style={{
                    width: `calc(${lineWidth}% - ${20 - 20 / (index.length - 1)}px)`,
                    left: `calc(${lineWidth * idx}% + ${19 - (20 / (index.length - 1)) * idx}px)`,
                  }}
                />
              );
            })}
          </div>
          {index.map((item, idx) => (
            <div
              className={classes.item}
              onMouseEnter={() => this.onSpeedDial(idx, true)}
              onMouseLeave={() => this.onSpeedDial(idx, false)}
              key={item.title}
            >
              <Tooltip
                title={parse(item.title)}
                placement="top"
                open={speedDial[idx]}
                classes={{ tooltip: classes.tooltip }}
                arrow
              >
                <div className={`${classes.itemMenu} ${speedDial[idx] ? classes.itemMenuActive : ''}`}>
                  {this.renderSubBlocks(item, idx)}
                  {this.renderPopups(item, idx, null, null)}
                </div>
              </Tooltip>
              <IconButton onClick={() => this.onClick(idx)} className={-scroll >= item.x - 10 ? classes.checked : ''}>
                <CircleIcon className={classes.icon} />
              </IconButton>
            </div>
          ))}
        </div>
      </>
    );
  }
}

Frise.propTypes = {
  classes: PropTypes.object.isRequired,
  scroll: PropTypes.number,
  data: PropTypes.object,
  index: PropTypes.array,
  onClick: PropTypes.func,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(Frise);
